<template>
  <comShopView v-if="mobile==false" />
  <comShopViewMob v-if="mobile==true" />
</template>

<script>
  import comShopView from '../components/comShopView.vue'
  import comShopViewMob from '../components/comShopViewMob.vue'

  export default {
    data: () => ({
      mobile: false,
    }),
    components: { comShopView, comShopViewMob },
    created() {
      this.mobile = this.$vuetify.display.mobile
    }
}
</script>